import type {ReactElement} from 'react';
import type {QRPhoneInput} from '@Libraries/qr-code/qr-code.types';
import {QRPhoneNumberField} from '@Components/qr-code-generator/components/qr-phone-number-field/qr-phone-number-field';
import type {QRFormProps} from '@Components/qr-code-generator/qr-code-generator.types';

export function QRPhoneForm({input, issues, onPatch}: QRFormProps<QRPhoneInput>): ReactElement {
  return (
    <QRPhoneNumberField
      value={input.phoneNumber}
      issues={issues}
      onValueChange={(phoneNumber): void => {
        onPatch({phoneNumber});
      }}
    />
  );
}
